module.exports = __webpack_public_path__ + "static/media/mellow-animation.f3e66b52.webm";